// 我的相关页面

export default [
  {
    path: '/thunder/customer',
    name: 'customer',
    component: () => import('@/views/mine/mine.vue'),
    meta: {
      title: '我的',
      level: 1,
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/orderlist',
    name: 'orderlist',
    component: () => import('@/views/mine/order_list.vue'),
    meta: {
      title: '账单详情',
    },
  },
  {
    path: '/thunder/order_details',
    name: 'order_details',
    component: () => import('@/views/mine/order_details.vue'),
    meta: {
      title: '账单详情',
    },
  },
  {
    path: '/thunder/refund',
    name: 'refund',
    component: () => import('@/views/mine/refund.vue'),
    meta: {
      title: '申请退款',
    },
  },
  {
    path: '/thunder/my_music',
    name: 'myMusic',
    component: () => import('@/views/appmusic/my_music'),
    meta: {
      title: '我的歌单',
    },
  },
  {
    path: '/thunder/my_record',
    name: 'myMusicRecord',
    component: () => import('@/views/mine/my_record'),
    meta: {
      title: '我的录音',
    },
  },
  {
    path: '/thunder/record_list',
    name: 'recordList',
    component: () => import('@/views/mine/record_list'),
    meta: {
      title: '我的录音',
    },
  },
  {
    path: '/thunder/record_share/:record',
    name: 'myMusicRecordShare',
    component: () => import('@/views/mine/record_share'),
    meta: {
      title: '我的录音',
    },
  },
  {
    path: '/thunder/video_share/:video',
    name: 'myVideoShare',
    component: () => import('@/views/mine/video_share'),
    meta: {
      title: '我的录音',
    },
  },
  {
    path: '/thunder/youxuan_ktv',
    name: 'YouxuanKtv',
    component: () => import('@/views/mine/youxuan'),
    meta: {
      title: '加入优选KTV',
    },
  },
  {
    path: '/thunder/customer/edit',
    name: 'customerEdit',
    component: () => import('@/views/mine/edit'),
    meta: {
      title: '个人信息',
    },
  },
  {
    path: '/thunder/customer/more',
    name: 'customerMore',
    component: () => import('@/views/mine/more'),
    meta: {
      title: '更多',
    },
  },
  {
    path: '/thunder/intercept_appeal',
    name: 'intercept_appeal',
    component: () => import('@/views/mine/intercept_appeal.vue'),
    meta: {
      title: '开通限制说明',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/appeal',
    name: 'appeal',
    component: () => import('@/views/mine/appeal.vue'),
    meta: {
      title: '申诉',
      notShowOrderList: true,
    },
  },
];
